import {
  AUTH0_AUDIENCE,
  AUTH0_CLIENT_DOMAIN,
  AUTH0_CLIENT_ID,
} from '../common/constants/env.constants';

import { IAuth0TokenResponse } from '../authentication/interfaces/auth0token.interface';
import axios from 'axios';

export const buildAuth0LoginUrl = (code_challenge?: string, redirect_uri?: string) => {
  return (
    `https://${AUTH0_CLIENT_DOMAIN}/authorize` +
    `?response_type=code` +
    `&client_id=${AUTH0_CLIENT_ID}` +
    `&redirect_uri=${redirect_uri ?? globalThis.origin + '/auth-callback'}` +
    `&scope=openid profile email offline_access Mail.ReadWrite MailboxSettings.ReadWrite` +
    `&audience=${AUTH0_AUDIENCE}` +
    `&prompt=login` +
    `&code_challenge=${code_challenge ?? ''}` +
    `&code_challenge_method=S256`
  );
};

export const auth0LogoutUrl = () => {
  return (
    `https://${AUTH0_CLIENT_DOMAIN}/v2/logout` +
    `?client_id=${AUTH0_CLIENT_ID}` +
    `&returnTo=${globalThis.origin}`
  );
};

export const handleAuthorizationCode = async (authorizationCode: string) => {
  const verifier = sessionStorage.getItem('@auth/code-verifier');
  const options = {
    method: 'POST',
    url: `https://${AUTH0_CLIENT_DOMAIN}/oauth/token`,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: new URLSearchParams({
      grant_type: 'authorization_code',
      client_id: `${AUTH0_CLIENT_ID}`,
      code: authorizationCode,
      redirect_uri: globalThis.origin + '/authentication/authRedirect.html',
      code_verifier: verifier ?? '',
    }),
  };

  try {
    const response = await axios.request(options);
    if (response.data) {
      const { refresh_token, access_token } = response.data;
      const auth0TokenResponse: IAuth0TokenResponse = { refresh_token, access_token };
      return auth0TokenResponse;
    }
  } catch (error) {
    console.error('Error handling auth0 authorization code', error);
  }
  return undefined;
};

export const refreshAccessToken = async (refreshToken: string) => {
  const options = {
    method: 'POST',
    url: `https://${AUTH0_CLIENT_DOMAIN}/oauth/token`,
    headers: { 'content-type': 'application/x-www-form-urlencoded' },
    data: new URLSearchParams({
      grant_type: 'refresh_token',
      client_id: `${AUTH0_CLIENT_ID}`,
      refresh_token: refreshToken,
    }),
  };

  try {
    const response = await axios.request(options);
    if (response.data) {
      const { access_token, refresh_token } = response.data;
      const auth0TokenResponse: IAuth0TokenResponse = {
        refresh_token,
        access_token,
      };
      return { auth0TokenResponse };
    }
  } catch (error) {
    console.error('Error refreshing access token', error);
    return { auth0TokenResponse: null };
  }

  return { auth0TokenResponse: null };
};
